import {
    applyMiddleware,
    combineReducers,
    compose,
    legacy_createStore as createStore,
} from "redux";
import {thunk} from "redux-thunk";
import userManagementReducer from "./user-management/reducer";
import transferLogReducer from "./transfer-log/reducer";
import dashboardReducer from "./dashboard/reducer";
import usersLogReducer from "./users-log/reducer";
import operatorManagementReducer from "./operator-management/reducer";
import groupManagementReducer from "./group-management/reducer";
import securityEventsReducer from "./security-events/reducer";
import gdprErasureLogReducer from "./gdpr-erasure-log/reducer";

const composeEnhancers = (process.env.NODE_ENV === 'development' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : null) || compose;

const rootReducer = combineReducers({
    userManagementReducer,
    transferLogReducer,
    dashboardReducer,
    usersLogReducer,
    operatorManagementReducer,
    groupManagementReducer,
    securityEventsReducer,
    gdprErasureLogReducer
});

// eslint-disable-next-line import/prefer-default-export
export const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));